var map = {
	"./beauty.png": "IIMe",
	"./calioh.png": "2WI4",
	"./countryharvest.png": "JVs3",
	"./cuttery.png": "XdL+",
	"./doncuco.png": "sOiF",
	"./imgs/calioh-coffee.png": "gmHy",
	"./imgs/country-food.jpg": "tz7s",
	"./imgs/doncuco-food.jpg": "Uinq",
	"./imgs/nothin-food.png": "TY/Q",
	"./imgs/punjab-food.jpg": "Fi0V",
	"./karate.png": "4pPw",
	"./logo.png": "7Otq",
	"./nothin.png": "xq3/",
	"./punjab.jpg": "/Mxc",
	"./punjab.png": "q+SS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0